'use client';

import { Box } from '@mui/material';
import type { ReactNode } from 'react';
import { OpenLecturePageBanner, type BannerTabKey } from './components/OpenLecturePageBanner';

interface Props {
  bannerTabKey?: BannerTabKey;
  children?: ReactNode;
}

export default function OpenLectureListLayout(props: Props) {
  const { bannerTabKey = 'list', children } = props;
  return (
    <Box className="OpenLectureListLayout-root" sx={{ pb: 8, background: '#fff' }}>
      <OpenLecturePageBanner tabKey={bannerTabKey} />
      {children}
    </Box>
  );
}
